import styled from "styled-components"

const UploadContent = styled.span`
  display: inline-block;
  height: 21px;
  border-radius: 15px;
  padding-left: 10px;
  padding-bottom: 2px;
  border: 1px solid ${props => props.theme.color.transferFilesBorder};
`

export default UploadContent
